import React, { lazy } from "react";
const Periods = lazy(() => import("../pages/commissions/periods"));
const PeriodDetail = lazy(() => import("../pages/commissions/periodDetail"));
const PaymentHistory = lazy(() => import("../pages/commissions/paymentHistory"));
const VolumeSummary = lazy(() => import("../pages/commissions/volumesummary"));
const PaymentHistoryDetail = lazy(() => import("../pages/commissions/paymentHistoryDetail"));

const routes = [
    {
        path: "periods",
        element: <Periods />
    },
    
    {
        path: "periods/:periodId/summary",
        element: <PeriodDetail />
    },
    {
        path: "periods/:periodId/volumesummary",
        element: <VolumeSummary />
    },
    {
        path: "payables",
        element: <PaymentHistory />
    },
    {
        path: "paid",
        element: <PaymentHistory />
    },
    {
        path: "paid/:batchId",
        element: <PaymentHistoryDetail />
    }
];

export default routes;